"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Wrapper = exports.StyledLink = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _mainLink = _interopRequireDefault(require("./mainLink"));

var _sharedStyle = require("../../styles/sharedStyle");

var StyledLink = (0, _styled.default)(_mainLink.default)(function (_ref) {
  var fonts = _ref.theme.fonts,
      enhanced = _ref.enhanced,
      color = _ref.color;
  return {
    fontSize: 'inherit',
    fontWeight: enhanced ? 'bold' : 'normal',
    fontFamily: fonts.body,
    lineHeight: 'inherit',
    color: color
  };
});
exports.StyledLink = StyledLink;
var Wrapper = (0, _styled.default)('span')(function (_ref2) {
  var hover = _ref2.hover,
      color = _ref2.color;
  return hover && _objectSpread(_objectSpread({}, (0, _sharedStyle.textHover)({
    color: color
  })), {}, {
    borderBottomColor: color === 'initial' ? '#000' : color,
    'a:hover &, &:hover': {
      borderBottomColor: 'transparent'
    }
  });
}, function (_ref3) {
  var enhanced = _ref3.enhanced,
      color = _ref3.color;
  return enhanced && _objectSpread(_objectSpread({}, (0, _sharedStyle.textHover)({
    color: color
  })), {}, {
    fontWeight: 'bold'
  });
});
exports.Wrapper = Wrapper;